import { ROLE_IDS, type RoleKeys } from "../../../constants/roles.ts"
import { type PermissionProjectPermissions } from "../../SettingsPermissions/types/permissions.types.ts"

interface ShowInvoiceSnapshotParams {
  userRole: RoleKeys
  projectPermissions?: PermissionProjectPermissions
}

export const getInvoiceSnapshotVisibility = ({
  userRole,
  projectPermissions
}: ShowInvoiceSnapshotParams): boolean => {
  if (
    ([ROLE_IDS?.CUSTOMER, ROLE_IDS?.SUBCONTRACTOR] as number[])?.includes(
      userRole
    )
  )
    return false

  return !!projectPermissions?.invoices?.project_invoice_view
}
